/**
 * @generated by @interxfi/j5-codegen (Plugin: NormalizedQueryPlugin) - do not edit */

import type { IxcGenerateV1MonthlyStatementsTaskState } from '@interxfi/types';
import { schema } from 'normalizr';

export const IXC_GENERATE_V1_MONTHLY_STATEMENTS_TASK_STATE_ENTITY_NAME = 'ixc.generate.v1.MonthlyStatementsTask';
export const ixcGenerateV1MonthlyStatementsTaskStateEntity = new schema.Entity<IxcGenerateV1MonthlyStatementsTaskState>(IXC_GENERATE_V1_MONTHLY_STATEMENTS_TASK_STATE_ENTITY_NAME, {}, { idAttribute: 'taskId' });

